import React, { useEffect, useState } from "react";
import Modal from "../../../../../parts/modal-new";
import useLoadImage from "../../../../../hooks/useLoadImage";

const PreviewPhotoModal = ({ toggleModal, photo, dontRefreshOnClose }) => {
  console.log("photo=", photo);
  const { type, pictureImg } = photo;
  const imgSrc = useLoadImage({ src: pictureImg });

  return (
    <Modal
      onClose={() => toggleModal()}
      dontRefreshOnClose={dontRefreshOnClose ? true : false}
      title={type}
      className={"preview-photo-modal"}
    >
      <div className="body">
        <img alt="test" src={imgSrc} />
      </div>
    </Modal>
  );
};

export default PreviewPhotoModal;
